export const QUARANTINE_ALLOWED_EMAIL = "almal@consultant.jobsohio.com";

const IMPORT_HISTORY_ALLOWED: string[] = [
  "almal@consultant.jobsohio.com",
  "thandra@consultant.jobsohio.com",
];

export function canAccessQuarantine(email: string): boolean {
  return email.toLowerCase() === QUARANTINE_ALLOWED_EMAIL;
}

// LinkedIn URL edit only — full edit rights still go through canAccessQuarantine
const LINKEDIN_EDIT_ALLOWED: string[] = [
  "brown@consultant.jobsohio.com",
];

export function canEditLinkedin(email: string): boolean {
  return canAccessQuarantine(email) || LINKEDIN_EDIT_ALLOWED.includes(email.toLowerCase());
}

export function canViewImportHistory(email: string): boolean {
  return IMPORT_HISTORY_ALLOWED.includes(email.toLowerCase());
}

const USERS_PAGE_ALLOWED: string[] = [
  "almal@consultant.jobsohio.com",
  "thandra@consultant.jobsohio.com",
];

export function canAccessUsers(email: string): boolean {
  return USERS_PAGE_ALLOWED.includes(email.toLowerCase());
}
